import React from 'react';
import { motion } from 'framer-motion';
import { DiagnosticProgress } from './DiagnosticProgress';

export const PageFrame = ({ children, pageNumber, showLogo = true, backgroundStyle = 'light' }) => {
  const bgClasses = {
    light: 'bg-background',
    dark: 'bg-secondary',
    gradient: 'bg-gradient-to-br from-secondary via-primary/20 to-background'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className={`min-h-screen ${bgClasses[backgroundStyle]} relative overflow-hidden`}
      data-testid="page-frame"
    >
      {/* Decorative background grid */}
      {backgroundStyle === 'light' && (
        <div 
          className="absolute inset-0 opacity-[0.03] pointer-events-none"
          style={{
            backgroundImage: 'linear-gradient(rgba(4,154,170,0.10) 1px, transparent 1px), linear-gradient(90deg, rgba(4,154,170,0.10) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }}
        />
      )}

      {/* Content */}
      <div className="relative z-10">
        {pageNumber && pageNumber > 2 && pageNumber < 10 && <DiagnosticProgress />}
        {children}
      </div>

      {/* Logo - bottom right */}
      {showLogo && (
        <div className="fixed bottom-6 right-6 opacity-60 hover:opacity-100 transition-opacity" data-testid="page-logo">
          <img 
            src="/trilogy-logo.png" 
            alt="Trilogy One Consulting" 
            className="h-8 w-auto"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}

      {/* Page number - bottom center */}
      {pageNumber && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 text-muted-foreground text-sm" data-testid="page-number">
          Page {pageNumber} of 10
        </div>
      )}
    </motion.div>
  );
};